import { ReponseEnveloppe } from '../../models/reponses/reponse-enveloppe';

export const reponseAnnulation: ReponseEnveloppe<boolean> = {
    reponse: true
}
